import { PanelType, Project } from '@nexxt/common/types';
import * as React from 'react';
import * as classnames from 'classnames';
import { alertMessage } from '../../../constants/alertMessage';
import CopyClipboard from '../CopyClipboard';
import Select from 'react-select';
import { PANEL_LIST } from '@nexxt/common/panels';
import { setValueToLocalStorage } from '@nexxt/common/utils/storage';
import Checkbox from '../Checkbox';
import { getLastAfterSplit } from '@nexxt/common/services/TextService';
import { props } from 'lodash/fp';

interface LinkGeneratorProps {
    toastNotification: any;
    chatbotURL: string;
    currentProject: Project;
    hidePanel?: boolean;
    hideTitle?: boolean;
    forceTestMode: boolean;
}
interface LinkGeneratorState {
    panelList: any[];
    showPanelpidIndex: number;
    panelpid: string;
    testMode: boolean;
}
class LinkGenerator extends React.Component<
    LinkGeneratorProps,
    LinkGeneratorState
> {
    state = {
        panelList: this.props.currentProject?.panelSettings?.panels || [],
        showPanelpidIndex: -1,
        panelpid: null,
        testMode: this.props.forceTestMode || false
    };
    componentDidUpdate(prevProps: LinkGeneratorProps): void {
        if (prevProps.currentProject !== this.props.currentProject) {
            this.setState({
                panelList: this.props.currentProject.panelSettings?.panels || []
            });
        }
    }

    addPanel = (): void => {
        const { panelList } = this.state;
        const addedPanelList = [
            ...panelList,
            { label: '', url: this.props.chatbotURL }
        ];
        this.savePanelToLocalStorage(addedPanelList);
    };

    changePanelSelect = (index: number, panel: any): void => {
        const { panelList, panelpid, showPanelpidIndex } = this.state;

        const copyPanelList = panelList;

        copyPanelList[index] = {
            ...panel,
            url:
                this.props.chatbotURL +
                `?src=${panel.value}${
                    panelpid ? `&${panel.project_id_parameter}=${panelpid}` : ''
                }`
        };

        if (panel.project_id_parameter && showPanelpidIndex === -1) {
            this.setState({ showPanelpidIndex: index });
            return;
        }
        this.savePanelToLocalStorage(copyPanelList);
    };

    removePanel = (index: number): void => {
        const { panelList } = this.state;

        panelList.splice(index, 1);
        this.savePanelToLocalStorage(panelList);
    };

    savePanelToLocalStorage = (panelList: any[]): void => {
        this.setState({ panelList });
        setValueToLocalStorage(
            `${this.props.currentProject.id}-panel`,
            panelList
        );
    };
    updateURLWithPanelpid = (index: number, panel: any) => {
        this.changePanelSelect(index, panel);

        this.setState({ panelpid: null, showPanelpidIndex: -1 });
    };

    setTestMode = () => {
        this.setState((prevState) => ({ testMode: !prevState.testMode }));
    };

    render(): React.ReactNode {
        const { panelList, testMode } = this.state;
        const { hidePanel, hideTitle, forceTestMode, currentProject } =
            this.props;
        const showPredefinedLink = !!currentProject?.predefinedAudience?.length;
        return (
            <div className="project-launch--link__body">
                {showPredefinedLink ? (
                    <div className="project-launch--link__body-block">
                        <p
                            className={classnames(
                                'project-launch--link__body-block-title',
                                { center: hidePanel }
                            )}
                        >
                            {!hideTitle && 'Link(s) to the survey'}
                            {!forceTestMode && (
                                <Checkbox
                                    className="project-launch--link__body-block-title-checkbox"
                                    disabled={forceTestMode}
                                    text={'Enable test mode'}
                                    value={'test'}
                                    onChange={this.setTestMode}
                                    defaultChecked={forceTestMode || testMode}
                                />
                            )}
                        </p>
                        {currentProject.predefinedAudience.map((group) => {
                            const quotaGroup = getLastAfterSplit(
                                group.groupValue,
                                '/'
                            );

                            return (
                                <>
                                    <p
                                        className={classnames(
                                            'project-launch--link__body-block-title'
                                        )}
                                    >
                                        {group.label}
                                    </p>
                                    <SurveyLink
                                        key={quotaGroup}
                                        onCopy={() =>
                                            this.props.toastNotification.info(
                                                alertMessage.COPY_SUCCESS
                                            )
                                        }
                                        chatbotURL={
                                            this.props.chatbotURL +
                                            `?quotaGroup=${quotaGroup}`
                                        }
                                        testMode={testMode}
                                    />
                                </>
                            );
                        })}
                    </div>
                ) : (
                    <div className="project-launch--link__body-block">
                        <p
                            className={classnames(
                                'project-launch--link__body-block-title',
                                { center: hidePanel }
                            )}
                        >
                            {!hideTitle && 'Link(s) to the survey'}
                            {!forceTestMode && (
                                <Checkbox
                                    className="project-launch--link__body-block-title-checkbox"
                                    disabled={forceTestMode}
                                    text={'Enable test mode'}
                                    value={'test'}
                                    onChange={this.setTestMode}
                                    defaultChecked={forceTestMode || testMode}
                                />
                            )}
                        </p>
                        {/** FOR OLD PROJECTS - SHOULDN't BE REQUIRED */}
                        {!panelList?.length && (
                            <SurveyLink
                                onCopy={() =>
                                    this.props.toastNotification.info(
                                        alertMessage.COPY_SUCCESS
                                    )
                                }
                                chatbotURL={this.props.chatbotURL}
                                testMode={testMode}
                            />
                        )}
                    </div>
                )}

                {!hidePanel && panelList?.length ? (
                    <div className="project-launch--link__body-block">
                        {/* <p className="project-launch--link__body-block-title">
                            Panel
                        </p> */}
                        <div className="project-launch--link__body-block-body">
                            {panelList.map((panel, index) => {
                                let chatbotUrl = this.props.chatbotURL;
                                if (index) {
                                    chatbotUrl += `?src=${
                                        panel.key || 'PANEL_NAME'
                                    }`;
                                }

                                if (panel.identifierKeys.length) {
                                    const qmarkOrAmpersand =
                                        chatbotUrl.includes('?') ? '&' : '?';
                                    let urlParams = '';

                                    panel.identifierKeys.forEach((param) => {
                                        urlParams =
                                            urlParams +
                                            qmarkOrAmpersand +
                                            `${param.identifierParamKey}={unique_id}`;
                                    });

                                    chatbotUrl = chatbotUrl + urlParams;
                                }

                                return (
                                    <div key={panel.key}>
                                        <p>
                                            <b>{panel.name || '(no name)'}</b>
                                        </p>
                                        <SurveyLink
                                            chatbotURL={chatbotUrl}
                                            testMode={testMode}
                                            onCopy={() => {}}
                                        />
                                    </div>
                                );
                            })}
                            {/* {panelList.map((panel, index) => {
                                // used to hide SurveyLink when panelPid is still needed
                                const waitingForPanelPid =
                                    panel?.project_id_parameter &&
                                    !this.state.showPanelpidIndex;

                                return (
                                    <div key={index}>
                                        <Select
                                            options={PANEL_LIST}
                                            value={panel}
                                            onChange={(value) =>
                                                this.changePanelSelect(
                                                    index,
                                                    value
                                                )
                                            }
                                        />

                                        {panel.url && !waitingForPanelPid && (
                                            <SurveyLink
                                                onCopy={() =>
                                                    this.props.toastNotification.info(
                                                        alertMessage.COPY_SUCCESS
                                                    )
                                                }
                                                chatbotURL={panel.url}
                                                testMode={testMode}
                                                removeLink={() =>
                                                    this.removePanel(index)
                                                }
                                            />
                                        )}
                                        {panel?.project_id_parameter &&
                                            this.state.showPanelpidIndex ===
                                                index && (
                                                <div className="project-launch--link__body-block-project-id">
                                                    <label className="form-group__label form-group--block">
                                                        ProjectID
                                                    </label>
                                                    <div className="row">
                                                        <input
                                                            className="form-group__control"
                                                            type="text"
                                                            name="panelpid"
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    panelpid:
                                                                        e.target
                                                                            .value
                                                                })
                                                            }
                                                        />
                                                        <button
                                                            className="btn btn--sm btn--blue"
                                                            disabled={
                                                                !this.state
                                                                    .panelpid
                                                            }
                                                            onClick={() =>
                                                                this.updateURLWithPanelpid(
                                                                    index,
                                                                    panel
                                                                )
                                                            }
                                                        >
                                                            Add
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                );
                            })}
                            <button
                                className="btn btn--sm btn--blue"
                                onClick={this.addPanel}
                            >
                                Add panel URL
                            </button> */}
                        </div>
                        {/* <div className="project-launch--link__body-block-footer">
                            Please contact us at{' '}
                            <span>{process.env.CONTACT_EMAIL_ADDRESS}</span> if
                            you couldn&apos;t find your panel group in the list
                        </div> */}
                    </div>
                ) : null}
                {/* <div className="project-launch--link__body-block">
                            <p className="project-launch--link__body-block-title">
                                Share on Social Media
                            </p>
                            <div className="project-launch--link__body-block-body flex">
                                {SOCIAL_MEDIA.map((media, index) => {
                                    return (
                                        <CopyToClipboard
                                            key={index}
                                            text={`${chatbotURL}?src=${media.source}`}
                                            onCopy={() =>
                                                toastNotification.info(
                                                    alertMessage.COPY_SUCCESS
                                                )
                                            }
                                        >
                                            <p className="project-launch--link__body-block-body-social-media">
                                                <FontAwesomeIcon
                                                    icon={
                                                        media.icon as IconDefinition
                                                    }
                                                />
                                            </p>
                                        </CopyToClipboard>
                                    );
                                })}
                            </div>
                        </div> */}
            </div>
        );
    }
}

export default LinkGenerator;

interface SurveyLinkProps {
    chatbotURL: string;
    testMode: boolean;
    onCopy: () => void;
    removeLink?: () => void;
}

export const SurveyLink: React.FC<SurveyLinkProps> = (
    props: SurveyLinkProps
) => {
    const chatbotURLChunks = props.chatbotURL.split('?');
    let chatbotURL = `${chatbotURLChunks[0]}${
        props.testMode ? '?testMode=true' : ''
    }`;

    if (chatbotURLChunks.length > 1) {
        chatbotURL = chatbotURL.includes('?')
            ? `${chatbotURL}&${chatbotURLChunks[1]}`
            : `${chatbotURL}?${chatbotURLChunks[1]}`;
    }
    return (
        <CopyClipboard
            className="project-launch--link__body-block-body"
            copyText={chatbotURL}
            onCopy={props.onCopy}
            removeClipboard={props.removeLink}
        />
    );
};
